import api from '@/api/auth'
import { AUTH_START, AUTH_SUCCESS, AUTH_CLEAR, AUTH_ERROR, AUTH_SET_REF_PARISH } from './mutations'

let timer = null
const refreshTokenInterval = 300000

export default {
  setRefParish: ({ commit }, parish) => {
    commit(AUTH_SET_REF_PARISH, parish)
  },
  refreshToken: async ({ commit, dispatch }) => {
    try {
      commit(AUTH_START)
      let { token } = await api.refresh()
      if (token) {
        localStorage.setItem('auth-token', token)
        commit(AUTH_SUCCESS, token)
      }
      timer = setTimeout(() => {
        dispatch('refreshToken')
      }, refreshTokenInterval)
    } catch (error) {
      commit(AUTH_CLEAR)
      throw new Error(error.message)
    }
  },
  authenticate: async ({ commit, dispatch }, credentials) => {
    try {
      commit(AUTH_START)
      const { token } = await api.authenticate(credentials)
      localStorage.setItem('auth-token', token)
      sessionStorage.removeItem('active-parish')
      commit(AUTH_SUCCESS, token)
      await dispatch('UserModule/loadProfile', {}, { root: true })
      timer = setTimeout(() => {
        dispatch('refreshToken')
      }, refreshTokenInterval)
    } catch (error) {
      commit(AUTH_ERROR)
      throw new Error(error.message)
    }
  },
  autologin: async ({ commit, dispatch }, code) => {
    try {
      await dispatch('logout')
      commit(AUTH_START)
      const { token } = await api.autologin(code)
      localStorage.setItem('auth-token', token)
      sessionStorage.removeItem('active-parish')
      commit(AUTH_SUCCESS, token)
      await dispatch('UserModule/loadProfile', {}, { root: true })
      timer = setTimeout(() => {
        dispatch('refreshToken')
      }, refreshTokenInterval)
    } catch (e) {
      commit(AUTH_ERROR)
      throw new Error(e.message)
    }
  },
  setToken: async ({ commit }, token) => {
    commit(AUTH_START)
    commit(AUTH_SUCCESS, token)
    localStorage.setItem('auth-token', token)
  },
  logout: async ({ commit, dispatch }) => {
    try {
      commit(AUTH_CLEAR, 'logout')
      commit(AUTH_SET_REF_PARISH, null)
      timer && clearTimeout(timer)
      await dispatch('UserModule/clearProfile', {}, { root: true })
      await dispatch('ParishModule/clear', {}, { root: true })
      sessionStorage.removeItem('active-parish')
    } catch (error) {
      throw new Error(error.message)
    }
  }
}
